import React from 'react';
import { cn } from '@/lib/utils';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  flush?: boolean;
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ flush, className, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'bg-white border border-gray-200 rounded-lg',
        !flush && 'p-6',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
);
Card.displayName = 'FlatCard';

const CardHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('mb-4', className)} {...props} />
  )
);
CardHeader.displayName = 'FlatCardHeader';

const CardTitle = React.forwardRef<HTMLHeadingElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <h3 ref={ref} className={cn('text-lg font-semibold text-gray-900', className)} {...props} />
  )
);
CardTitle.displayName = 'FlatCardTitle';

const CardBody = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('text-gray-600', className)} {...props} />
  )
);
CardBody.displayName = 'FlatCardBody';

export { Card, CardHeader, CardTitle, CardBody };
export type { CardProps };
